
        import 'Toggle.86d3cf9.css-module'
        export default {"toggle":"toggle_Toggle_86d3cf9"}
    